import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// env
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';
import { IndexedStorageService } from './indexed-storage.service';
// encrypt
// import { DecryptPipe, EncryptPipe } from '../pipes/encrypt-decrypt.pipe';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user_data: any = null;
  u_t: string = environment.qsToken;
  logged: boolean = false;
  interval: number = 30000;

  constructor(
    // private http: HttpClient,
    private router: Router,
    private firebaseService: FirebaseService,
    private indexedStorage: IndexedStorageService
  ) {
    void this.initializeSessionState();
  }
  // private getHeaders() {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Token ' + this.u_t
  //     })
  //   };

  //   return httpOptions;
  // }
  /**
   * sign in user in QServus
   * @param credentials 
   */
  login(credentials: { email: string, password: string }, api_domain: string) {
    type AuthResponse = Record<string, unknown>;
    return new Promise(async (resolve, reject) => {
      const fnRes = await this.firebaseService.callFunction<AuthResponse>('loginQServus', { "credentials": credentials, api_domain: api_domain })
      resolve(fnRes.data)
    })
    // return this.http.post(environment.qsApiQSSUrl + "sign_in/", credentials).toPromise();
  }
  /**
   * close current session
   */
  async logout() {
    this.user_data = null
    this.logged = false
    
    try {
      // Remove from IndexedDB
      await Promise.all([
        this.indexedStorage.removeItem("qservus-surv-user-data"),
        this.indexedStorage.removeItem("logged"),
        this.indexedStorage.removeItem("qs_api_domain")
      ]);
    } catch (error) {
      console.warn('Error removing items from IndexedDB, falling back to localStorage:', error);
      // Fallback to localStorage
      localStorage.removeItem("qservus-surv-user-data")
      localStorage.removeItem("logged")
      localStorage.removeItem("qs_api_domain")
    }
    
    this.router.navigate(["/login"])
  }
  /**
   * get user data
   * @param email 
   */
  getUserData(email: string, api_domain: string) {
    type AuthResponse = Record<string, unknown>;
    return new Promise(async (resolve, reject) => {
      const fnRes = await this.firebaseService.callFunction<AuthResponse>('getUserDataQServus', { "email": email, "api_domain": api_domain })
      resolve(fnRes.data)
    })
    // return this.http.post(environment.qsApiQSSUrl + "user_data/", { "email": email }, this.getHeaders()).toPromise();
  }
  /**
   * get local user data
   */
  async getUserDataLocal() {
    try {
      // Try IndexedDB first
      const d = await this.indexedStorage.getItem<string>("qservus-surv-user-data");
      if (d != null) {
        this.user_data = typeof d === 'string' ? JSON.parse(d) : d;
        return;
      }
    } catch (error) {
      console.warn('Error getting user data from IndexedDB:', error);
    }
    
    // Fallback to localStorage
    try {
      const d = localStorage.getItem("qservus-surv-user-data");
      if (d != undefined) {
        this.user_data = JSON.parse(d);
        // Store in IndexedDB for next time
        this.indexedStorage.setJsonItem("qservus-surv-user-data", this.user_data).catch(console.warn);
      }
    } catch (error) {
      console.error('Error getting user data from localStorage:', error);
    }
  }

  private async syncLoggedStatus() {
    try {
      const logged = await this.indexedStorage.getItem<string>("logged");
      if (logged !== null) {
        this.logged = logged === "true";
        return;
      }
    } catch (error) {
      console.warn('Error checking login status from IndexedDB:', error);
    }
    this.logged = localStorage.getItem("logged") == "true";
  }

  private async initializeSessionState() {
    await this.getUserDataLocal();
    await this.syncLoggedStatus();
  }
  /**
 * store user data from login
 * @param data 
 */
  async setUserData(data: any) {
    this.user_data = data;
    this.logged = true;
    
    try {
      // Store in IndexedDB
      await Promise.all([
        this.indexedStorage.setJsonItem("qservus-surv-user-data", this.user_data),
        this.indexedStorage.setItem("logged", "true")
      ]);
    } catch (error) {
      console.warn('Error storing user data in IndexedDB, falling back to localStorage:', error);
      // Fallback to localStorage
      localStorage.setItem("qservus-surv-user-data", JSON.stringify(this.user_data));
      localStorage.setItem("logged", "true");
    }
  }
  // check if any user is logged
  isLogged(): boolean {
    return this.logged;
  }
  /**
   * save session PIN code for access to admin page
   * @param pin 
   */
  savePin(pin: string) {
    // this.user_data["pin"] = this.encryptPipe.transform(pin);
    this.setUserData(this.user_data);
  }
  /**
   * evaluate PIN Code
   * @param pin 
   */
  validatePin(pin: string) {
    return new Promise((res, rej) => {
      if (this.user_data.pin != undefined) {
        // const conversionDecryptOutput = this.decryptPipe.transform(this.user_data.pin);
        // res(pin == conversionDecryptOutput);
      } else res(false);
    })
  }
  setPinTimestamp() {
    const p_data = {
      until: new Date().getTime() + this.interval
    }
    localStorage.setItem("pin_validated", JSON.stringify(p_data));
  }
}
